<!-- Active product with: deviant driver as future regular driver -->
<wuc-display-field class="insurance-regular-driver-future__display-field" *ngIf="isActiveProduct && hasRegularDriverFuture">
    <label>Toekomstig(e) bestuurder</label>
    {{ regularDriverFutureName }} <small *ngIf="purchasedProduct?.productDetails?.regularDriverFuture?.startDate">
    (per {{ purchasedProduct?.productDetails?.regularDriverFuture?.startDate | dateFormat }})</small>
    <ng-container slot="action">
        <wuc-link type="secondary" iconSize="xs" (clicked)="openInsuranceRegularDriverModal()"
                    iconRight="cross-closed">Annuleren
        </wuc-link>
    </ng-container>
</wuc-display-field>

<!-- Active product with: policy holder as future regular driver -->
<wuc-display-field class="insurance-regular-driver-future__display-field"  *ngIf="isActiveProduct && isPolicyHolder">
    <label>Toekomstig(e) bestuurder</label>
    Ikzelf
    <small *ngIf="purchasedProduct?.productDetails?.regularDriver?.endDate">
        (per {{ purchasedProduct?.productDetails?.regularDriver?.endDate | dateFormat }})
    </small>
    <ng-container slot="action">
        <wuc-link type="secondary" iconSize="xs" (clicked)="openInsuranceRegularDriverModal()"
                  iconRight="cross-closed">Annuleren
        </wuc-link>
    </ng-container>
</wuc-display-field>
